import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function FinalCTA() {
  const benefits = ['Asesoría gratuita de 15 minutos', 'Propuesta personalizada para tu negocio', 'Sin compromisos ni letras pequeñas'];
  return <section className="py-32 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #0a0a1e 0%, #0d1b3e 100%)'
  }} data-id="element-141">
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-143">
          <h2 className="text-4xl md:text-5xl font-bold text-nova-text" data-id="element-144">
            ¿Listo Para Que Tu Negocio Domine Internet?
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-6 mb-6" data-id="element-145" />

          <p className="text-xl text-nova-text-muted mb-4" data-id="element-146">
            Cada día que pasa sin una página web profesional es un día que tu
            competencia te gana clientes.
          </p>
          <p className="text-2xl font-semibold text-nova-text mb-8" data-id="element-147">
            El momento de actuar es HOY.
          </p>
          <p className="text-lg text-nova-text-muted mb-10" data-id="element-148">
            NovaWeb está listo para transformar tu negocio en una máquina de
            atraer clientes.
          </p>

          <div className="bg-nova-card/50 backdrop-blur-sm border border-nova-accent/20 rounded-2xl p-8 max-w-2xl mx-auto mb-12" data-id="element-149">
            <h3 className="text-xl font-semibold text-nova-text mb-6" data-id="element-150">
              Escríbenos ahora y recibe:
            </h3>
            <ul className="space-y-4 text-left max-w-md mx-auto mb-8" data-id="element-151">
              {benefits.map((benefit, index) => <li key={index} className="flex items-center gap-3" data-id="element-152">
                  <CheckCircle2 className="text-nova-accent shrink-0" size={24} data-id="element-153" />
                  <span className="text-nova-text text-lg" data-id="element-154">{benefit}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-155">
            <a href="#contacto" className="w-full sm:w-auto text-center px-10 py-4 rounded-full font-bold bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.7)] hover:scale-105 transition-all duration-300 text-lg" data-id="element-156">
              QUIERO MI PÁGINA WEB AHORA
            </a>
            <a href="#portafolio" className="w-full sm:w-auto text-center px-10 py-4 rounded-full font-bold bg-transparent border-2 border-[#00D4FF] text-white hover:bg-[#00D4FF]/10 transition-all duration-300 text-lg" data-id="element-157">
              VER PORTAFOLIO
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}